import { debugLog } from 'shared/logger/debugLog';
import { objHasKey } from 'shared/utils/object';
import {
  DocumentPatchOutDto,
  DocumentUpdatePayload,
} from './document';

export function toDocumentPatchOutDto(
  payload: DocumentUpdatePayload
): DocumentPatchOutDto {
  debugLog('[toDocumentPatchOutDto] payload (what we receive)', payload);

  const result: DocumentPatchOutDto = {};

  if (objHasKey(payload, 'description') && payload.description !== undefined) {
    result.description = payload.description;
  }

  if (
    objHasKey(payload, 'imageRotation') &&
    payload.imageRotation !== undefined
  ) {
    result.imageRotation = payload.imageRotation;
  }

  if (objHasKey(payload, 'data.type') && payload['data.type'] !== undefined) {
    result.fileType = payload['data.type'];
  }

  if (
    objHasKey(payload, 'data.isDrawn') &&
    payload['data.isDrawn'] !== undefined
  ) {
    result.isDrawn = payload['data.isDrawn'];
    result.drawings = payload['data.isDrawn']
      ? [
          {
            ...(objHasKey(payload, 'data.drawnUploadStatus') &&
              payload['data.drawnUploadStatus'] !== undefined && {
                drawnUploadStatus: payload['data.drawnUploadStatus'],
              }),
            ...(objHasKey(payload, 'data.mergedUploadStatus') &&
              payload['data.mergedUploadStatus'] !== undefined && {
                mergedUploadStatus: payload['data.mergedUploadStatus'],
              }),
          },
        ]
      : [];
  }

  debugLog('[toDocumentPatchOutDto] result (what we send in PUT body)', result);
  return result;
}
